import { useEffect, useMemo, useState } from 'react';
import { useAdminApi } from '../../../lib/adminApi';
import RepeaterEditor from '../components/RepeaterEditor';

const defaults = {
  sectionId: "Tickets",
  title: "Tickets",
  ctaAnchor: "#Ticketreservierung",
  tiers: [{ title:'', price:'', icon:'lni-ticket' }]
};

export default function TicketsEditor(){
  const api = useAdminApi();
  const [doc, setDoc] = useState(defaults);
  const [orig, setOrig] = useState(defaults);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const dirty = useMemo(()=>JSON.stringify(doc)!==JSON.stringify(orig), [doc,orig]);

  useEffect(()=>{ let alive=true;(async()=>{
    setLoading(true);
    try { const res = await api.get('/sections/tickets'); if(!alive) return;
      const merged = { ...defaults, ...(res||{}) }; setDoc(merged); setOrig(merged);
    } finally { setLoading(false); }
  })(); return ()=>{alive=false}; },[]); // eslint-disable-line

  const onSave = async() => { setSaving(true); setError('');
    try{ await api.put('/sections/tickets', doc); setOrig(doc); setEditing(false); }
    catch(e){ setError(e?.message || 'Save failed'); }
    finally{ setSaving(false); }
  };

  if (loading) return <Spinner/>;

  const readOnly = !editing;

  return (
    <div>
      <Toolbar title="Tickets" editing={editing} setEditing={setEditing} onSave={onSave} onCancel={()=>{setDoc(orig); setEditing(false);}} saving={saving} dirty={dirty}/>
      {error && <div className="alert alert-danger m-3 py-2">{error}</div>}
      <div className="p-3">
        <Row>
          <Col><Text label="Titel" value={doc.title} onChange={(v)=>setDoc(d=>({...d, title:v}))} readOnly={readOnly}/></Col>
        </Row>

        <RepeaterEditor
          title="Ticket-Tiers"
          items={doc.tiers}
          onChange={(v)=>setDoc(d=>({...d, tiers:v}))}
          template={{ title:'', price:'', icon:'lni-ticket' }}
          renderFields={(it, patch)=>(
            <Row>
              <Col><Text label="Titel" value={it.title} onChange={(v)=>patch({title:v})} readOnly={readOnly}/></Col>
              <Col><Text label="Preis" value={it.price} onChange={(v)=>patch({price:v})} readOnly={readOnly}/></Col>
            </Row>
          )}
        />
      </div>
    </div>
  );
}
function Toolbar(p){ return CarouselToolbar(p); }
function Spinner(){ return (<div className="p-4 text-center"><div className="spinner-border brand-spinner" role="status" /><div className="small mt-2 text-muted">Lädt…</div></div>); }
const CarouselToolbar = ({ title, editing, setEditing, onSave, onCancel, saving, dirty }) => (
  <div className="editor-toolbar">
    <div className="d-flex align-items-center gap-2">
      <h4 className="editor-title m-0">{title}</h4>
      {editing && dirty && <span className="badge-soft">• Ungespeicherte Änderungen</span>}
    </div>
    <div className="d-flex align-items-center gap-2">
      {!editing ? <button className="btn btn-sm btn-edit" onClick={()=>setEditing(true)}>Bearbeiten</button> : (
        <>
          <button className="btn btn-sm btn-save" onClick={onSave} disabled={!dirty || saving}>{saving ? 'Speichert…' : 'Speichern'}</button>
          <button className="btn btn-sm btn-cancel" onClick={onCancel} disabled={saving}>Abbrechen</button>
        </>
      )}
    </div>
  </div>
);
function Text({label, value, onChange, readOnly}){ return (<div className="mb-3"><label className="form-label">{label}</label><input className="form-control" value={value||''} onChange={e=>onChange(e.target.value)} readOnly={readOnly}/></div>); }
const Row = ({children}) => <div className="row">{children}</div>;
const Col = ({children}) => <div className="col-md-4">{children}</div>;
